import {path} from 'ramda'
import {getAuthenticatedAdminAresClient} from '@modifi/trade-api-clients'
import {
  MATCH_TYPE_INVOICE_DD_RETURN,
  MATCH_TYPE_INVOICE_FUNDS_TRANSFER,
  MATCH_TYPE_INVOICE_REPAYMENT,
  MATCH_TYPE_PAYMENT_DD_RETURN,
  MATCH_TYPE_PAYMENT_FUNDS_TRANSFER,
  MATCH_TYPE_PAYMENT_PASS_THROUGH,
  MATCH_TYPE_PAYMENT_REPAYMENT,
  TRANSACTION_TYPE_INVOICE_FUNDS_TRANSFER,
  TRANSACTION_TYPE_INVOICE_REPAYMENT,
} from '../constants'

const invoiceRequest = transactionType => (state, data) => {
  const {
    sourceEntity: {id: transactionId},
    targetEntity: {id: invoiceId},
  } = data
  const body = {transactionId, transactionType}
  const client = getAuthenticatedAdminAresClient()
  return client.Invoices.attachTransaction({
    invoiceId,
    body,
  })
}

export const matchTypeRequest = {
  // matching transaction to funds transfer
  [MATCH_TYPE_PAYMENT_FUNDS_TRANSFER]: (state, data) => {
    const {
      sourceEntity: {id: transactionId},
      targetEntity: payment,
    } = data
    const paymentId = payment.id
    const fundsTransfer = path(['fundsTransfers', 0], payment)
    const fundsTransferId = fundsTransfer.id
    const body = {
      paymentId,
      fundsTransferId,
      transactionType: MATCH_TYPE_PAYMENT_FUNDS_TRANSFER,
      transactionId,
    }
    const client = getAuthenticatedAdminAresClient()
    return client.Payments.attachTransactionToFundsTransfer({
      paymentId,
      fundsTransferId,
      body,
    })
  },
  // matching transaction to repayment
  [MATCH_TYPE_PAYMENT_REPAYMENT]: (state, data) => {
    const {
      sourceEntity: {id: transactionId},
      targetEntity: {id: paymentId, isBuyerReduction},
    } = data
    const body = {
      transactionType: MATCH_TYPE_PAYMENT_REPAYMENT,
      transactionId,
      paymentId,
      isBuyerReduction,
    }
    const client = getAuthenticatedAdminAresClient()
    return client.Payments.attachTransactionToRepayment({
      paymentId,
      body,
    })
  },
  // matching transaction to invoice funds transfer
  [MATCH_TYPE_INVOICE_FUNDS_TRANSFER]: invoiceRequest(TRANSACTION_TYPE_INVOICE_FUNDS_TRANSFER),
  // matching transaction to invoice repayment
  [MATCH_TYPE_INVOICE_REPAYMENT]: invoiceRequest(TRANSACTION_TYPE_INVOICE_REPAYMENT),
  // matching returning direct debit transaction to repayment
  [MATCH_TYPE_PAYMENT_DD_RETURN]: (state, data) => {
    const {
      sourceEntity: {id: transactionId},
      targetEntity: {id: paymentId},
      directDebitExecutionDate,
    } = data
    const body = {
      transactionType: MATCH_TYPE_PAYMENT_REPAYMENT,
      transactionId,
      paymentId,
      isBuyerReduction: false,
      directDebitExecutionDate,
    }
    const client = getAuthenticatedAdminAresClient()
    return client.Payments.attachTransactionToRepayment({
      paymentId,
      body,
    })
  },
  // matching returning direct debit transaction to invoice repayment
  [MATCH_TYPE_INVOICE_DD_RETURN]: (state, data) => {
    const {
      sourceEntity: {id: transactionId},
      targetEntity: {id: invoiceId},
      directDebitExecutionDate,
    } = data
    const body = {
      transactionId,
      transactionType: TRANSACTION_TYPE_INVOICE_REPAYMENT, // classified as invoice repayment on purpose
      directDebitExecutionDate,
    }
    const client = getAuthenticatedAdminAresClient()
    return client.Invoices.attachTransaction({
      invoiceId,
      body,
    })
  },
  // matching transaction to pass-through repayment
  [MATCH_TYPE_PAYMENT_PASS_THROUGH]: (state, data) => {
    const {
      sourceEntity: {id: transactionId},
      targetEntity: {id: paymentId, isBuyerReduction},
    } = data
    const body = {
      transactionType: MATCH_TYPE_PAYMENT_REPAYMENT,
      transactionId,
      paymentId,
      isBuyerReduction,
    }
    const client = getAuthenticatedAdminAresClient()
    return client.Payments.attachTransactionToRepayment({
      paymentId,
      body,
    })
  },
}
